import { render, staticRenderFns } from "./FirmAboutPage.vue?vue&type=template&id=67372819&scoped=true"
import script from "./FirmAboutPage.vue?vue&type=script&lang=js"
export * from "./FirmAboutPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67372819",
  null
  
)

export default component.exports